// WARNING: This file is auto-generated. Do not edit directly.
export const responsiveTokens = {
  fontSize: {
    heading: {
      h1: '36px',
      h2: '24px',
      h3: '18px',
    },
    body: {
      body1: '14px',
      body2: '12px',
      body3: '12px',
    },
  },
  lineHeight: {
    heading: {
      h1: '40px',
      h2: '32px',
      h3: '24px',
    },
    body: {
      body1: '24px',
      body2: '20px',
      body3: '20px',
    },
  },
  spacing: {
    xsNegative: '-4px',
    none: '0px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '40px',
    '4xl': '80px',
  },
  borderRadius: {
    none: '0px',
    sm: '4px',
    md: '8px',
    xl: '16px',
    '2xl': '24px',
  },
  borderWidth: {
    xs: '1px',
  },
} as const;
export type ResponsiveTokens = typeof responsiveTokens;
